export const ADD_REVIEW_MODAL = {
  en: {
    title: "Add Review",
    description: "",
    reviewLabel: "How was your experience ?",
    reviewPlaceholder: "Please write your feedback"
  },
  ar: {
    title: "إضافة تقييم",
    description: "",
    reviewLabel: "كيف كانت تجربتك؟",
    reviewPlaceholder: "ضع تقييمك هنا"
  },
};

export const PLAN_ERROR_MESSAGE = {
  en: "To access voice sessions, you must upgrade to a premium plan.",
  ar: "للوصول إلى الجلسات الصوتية، يجب عليك الترقية إلى الاشتراك المميز Premium.",
}


export const CHAT_POPUP = {
  en: {
    summaryText: "Summary Generated:",
    inputPlaceholder: "Talk to Dr. Salah....",
    endSessionText: "End Session",
    sureText: "Are you sure you want to end this session?",
    endSessionBtnText: "End Session",
    cancelText: "Cancel",
    continueSessionText:"You can continue this session from where you left",
    sessionCantBeContinuedText:"Session can't be continued",
  },
  ar: {
    summaryText: "ملخص الجلسة:",
    inputPlaceholder: "تحدث مع الدكتور صلاح....",
    endSessionText: "إنهاء الجلسة",
    sureText: "هل أنت متأكد أنك تريد إنهاء هذه الجلسة؟",
    endSessionBtnText: "إنهاء الجلسة",
    cancelText: "إلغاء",
    continueSessionText:"يمكنك متابعة هذه الجلسة من حيث توقفت",
    sessionCantBeContinuedText:"لا يمكن استمرار الجلسة",
  },
};


export const DELETE_REVIEW_MODAL = {
  en: {
    title: "Delete Review",
    description: "Are you sure you want to remove this review?",
    btnText: ["Cancel", "Remove"],
    successMessage: "Review deleted successfully",
  },
  ar: {
    title: "حذف التقييم",
    description: "هل أنت متأكد أنك تريد حذف التقييم؟",
    btnText: ["إلغاء", "حذف"],
    successMessage: "تم حذف التقييم بنجاح",
  },
};


export const DOWNLOAD_SUMMARY_MODAL = {
  en: {
    title: "Download Summary",
    description: "Download your session summary",
    btnText: ["Maybe Later", "Download PDF"],
  },
  ar: {
    title: "تحميل ملخص الجلسة",
    description: "تحميل ملخص جلستك",
    btnText: ["ربما لاحقًا", "تحميل ملف PDF"],
  },
};


export const HELP_SUPPORT_READ_MORE_MODAL = {
  en: {
    title: "Getting Started",
    description: "How to start your first Session",
    btnText: ["Read More", "Contact Us"],
    helpText: "Need Help?",
    helpSubText: "Still unsure? Tap 'Contact Us' to get in touch with our support team.",
  },
  ar: {
    title: "البدء",
    description: "كيفية بدء جلستك الأولى",
    btnText: ["اقرأ المزيد", "اتصل بنا"],
    helpText: "هل تحتاج إلى مساعدة؟",
    helpSubText: "ما زلت غير متأكد؟ اضغط على 'اتصل بنا' للتواصل مع فريق الدعم.",
  },
};


export const SESSION_ACTIONS_MODAL = {
  en: {
    title: "Session Actions",
    actionTitle: "Save Training Session",
    btnText: ["Generate Summary", "Save Session"],
    btnText2: ["Save as Draft", "Publish Session"],
  },
  ar: {
    title: "إجراءات الجلسة",
    actionTitle: "حفظ الجلسة",
    btnText: ["تحميل الملخص", "بدء الجلسة"],
    btnText2: ["حفظ كمسودة", "نشر الجلسة"],
  },
};


export const START_CHAT_MODAL = {
  en: {
    title: "Start Session",
    btnText: ["Text", "Voice"],
  },
  ar: {
    title: "بدء الجلسة",
    btnText: ["كتابة", "صوت"],
  },
};


export const VOICE_CHAT_POPUP_MODAL = {
  en: {
    headTitle: "Now talking about",
    btnText: ["Live Transcript", "Close", "End Session"],
    btnText2: ["Stop", "Start", "Unmute", "Mute"],
    confirmText: "Are you sure you want to end this session?",
    cancelText: "Cancel",
    continueSessionText:"You can continue this session from where you left",
    sessionCantBeContinuedText:"Session can't be continued",
  },
  ar: {
    headTitle: "الآن يتحدث عن",
    btnText: ["نص المحادثة", "إغلاق", "إنهاء الجلسة"],
    btnText2: ["إيقاف", "بدء", "إيقاف الصوت", "الصوت"],
    confirmText: "هل أنت متأكد أنك تريد إنهاء هذه الجلسة؟",
    cancelText: "إلغاء",
    continueSessionText:"يمكنك متابعة هذه الجلسة من حيث توقفت",
    sessionCantBeContinuedText:"لا يمكن استمرار الجلسة",
  },
};
